"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/state/globalStore";
import { type PutVersionRequest } from "@/generated/fastapi";
import { putVersion } from "../api/putVersion";
import { versioningKeys } from "../queries/keys";

export default function useUpdateVersionMutation() {
  const queryClient = useQueryClient();
  const { accessToken } = useAuth();

  return useMutation({
    mutationFn: (request: PutVersionRequest) =>
      putVersion(accessToken, request),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: versioningKeys.all }),
  });
}
